import { Typography } from '@sm/wds-react';
import React, { ReactElement } from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  accountName: {
    width: '300px',
  },
  truncate: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});

const AccountName = ({ username }: { username: string }): ReactElement => {
  const { accountName, truncate } = useStyles({});
  return (
    <div className={accountName}>
      <Typography component="div" variant="bodySm">
        <div data-testid="AccountName__Username" className={truncate}>
          <strong>{username}</strong>
        </div>
      </Typography>
    </div>
  );
};

export default AccountName;
